import { render, staticRenderFns } from "./AppTopNavigation.vue?vue&type=template&id=422917c4&"
import script from "./AppTopNavigation.vue?vue&type=script&lang=js&"
export * from "./AppTopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports